export enum SortName {
    Name = 'Name',
    Date = 'Date',
    DateModification = "Date of modification",
    DateTrashing = "Date of trashing"
  }
  